import type { SwitchProps } from "@mui/material"
import { FormControlLabel, Switch } from "@mui/material"
import type { ReactElement } from "react"
import { forwardRef } from "react"

export interface AerosSwitchProps extends Omit<SwitchProps, "onChange"> {
  label?: string
  onChange?: (checked: boolean) => void
}

export const AerosSwitch = forwardRef<HTMLButtonElement, AerosSwitchProps>(
  ({ label, disabled, onChange, ...props }, ref): ReactElement => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked)
    }

    return (
      <FormControlLabel
        control={<Switch {...props} ref={ref} onChange={handleChange} />}
        label={label}
        disabled={disabled}
      />
    )
  }
)
